import React from "react";
import { CloseIcon } from "@assets/svgIcons";
import { COLUMNS } from "@src/dashbaordAdmin/HomePage/homePageData";
import "./index.scss";

const ViewDetailsModal = ({ isOpen, onClose, data }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="modal-overlay" onClick={onClose} />
      <div className="view-details-modal">
        <div className="modal-header">
          <h2 className="modal-title">Submission Details</h2>
          <button
            className="modal-close-btn"
            onClick={onClose}
            aria-label="Close modal"
          >
            <CloseIcon />
          </button>
        </div>

        <div className="modal-content">
          {COLUMNS.map((col) => (
            <div key={col.key} className="detail-row">
              <span className="detail-label">{col.label}:</span>
              <span className="detail-value">{data[col.key] || "N/A"}</span>
            </div>
          ))}
        </div>

        <div className="modal-footer">
          <button className="modal-close-footer-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </>
  );
};

export default ViewDetailsModal;
